// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"vd","innerTile":"wd","heading":"xd","instaTileBtn":"yd","disabled":"zd","instaTileElement":"Ad","instagramPic":"Bd"};